module.exports = new __parcel__URL__("first_tab_content_zh-cn.40d9aa09.webp").toString();